import { toTrendSeries, type TrendPoint } from '@liza/ui/utils/observation';
import type { WithId } from '@medplum/core';
import type { Observation } from '@medplum/fhirtypes';
import { useMemo } from 'react';

/** Memoized {@link toTrendSeries} — shared by the sparkline and the detailed care-plan chart. */
export const useTrendSeries = (results: WithId<Observation>[]): { data: TrendPoint[]; hasSecondLine: boolean } =>
  useMemo(() => toTrendSeries(results), [results]);
